



















































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { CAR_INSURANCE } from '@/utils/const'
import uploadFiles from '@/utils/helper/uploadFiles'
import { debounce } from '@/utils/util'
import RulesApi from '@/api/rules'
import moment from 'moment'
const ALL_INSURANCE = '-1'
const debounceUpload = debounce(300)

@Component({})
export default class GeneralConfigure extends Vue {
	private VIRTUAL_NUMBER = '1' // 虚拟号
	private BUSINESS_COOPERATION = '2' // 业务合作
	private MANUAL = '3' // 服务手册配置
	private IMAGE_PDF = '4' // 影像信息PDF版
	private DETAIL_FORBIDDEN = '5' // 完成后天数配置 - 禁止查看详情
	private AUDIT_CANCEL = '6'
	private DISABLE_MANUAL = '7'
	private DIABLE_SMS = '8'
	private AUTO_SIGN = '9'
	private SETTLE_SYSTEM = '10'
	private businessOptions = [
		{
			label: '车险全流程业务',
			value: '01',
		},
	]
	private virtualNumberOptions = [
		{
			label: '禁用虚拟号',
			value: '01',
		},
	]
	private visible = false
	private generalForm: any = {}
	private displayList: string[] = []
	private manual: any = {}

	@Prop({})
	private insuranceType!: any

	@Prop({})
	private initialData!: any

	@Watch('insuranceType', { immediate: true })
	private onInsuranceChange() {
		let list: string[] = []
		if ([ALL_INSURANCE].includes(this.insuranceType)) {
			list = [
				this.VIRTUAL_NUMBER,
				this.IMAGE_PDF,
				this.DETAIL_FORBIDDEN,
				this.AUDIT_CANCEL,
				this.DIABLE_SMS,
				this.DISABLE_MANUAL,
				this.AUTO_SIGN,
				this.SETTLE_SYSTEM,
			]
		} else if ([CAR_INSURANCE].includes(this.insuranceType)) {
			list = [this.MANUAL, this.BUSINESS_COOPERATION]
		}
		this.displayList = list
	}

	@Watch('initialData', { immediate: true })
	private onDataChange() {
		if (!this.initialData) {
			return
		}
		this.manual = this.initialData.manual
		const {
			packagePdf,
			restrictDays,
			virtualNumber,
			wholeProcess,
			auditCancel,
			disableSms,
			disabelManual,
			autoSign,
			beforeBusinessLine,
			afterBusinessLine,
			effectDate,
		} = this.initialData

		this.$nextTick(() => {
			let initialFields: any = {}
			if (
				this.displayList.includes(this.VIRTUAL_NUMBER) &&
				virtualNumber === '1'
			) {
				initialFields.virtualNumber = ['01']
			}
			if (
				this.displayList.includes(this.BUSINESS_COOPERATION) &&
				wholeProcess === '1'
			) {
				initialFields.businessCooperation = ['01']
			}
			if (this.displayList.includes(this.IMAGE_PDF)) {
				initialFields.packagePdf = packagePdf === '1'
			}
			if (this.displayList.includes(this.AUDIT_CANCEL)) {
				initialFields.auditCancel = auditCancel === '1'
			}
			if (this.displayList.includes(this.DETAIL_FORBIDDEN)) {
				initialFields.restrictDays = restrictDays
			}
			if (this.displayList.includes(this.DISABLE_MANUAL)) {
				initialFields.disabelManual = disabelManual === '1'
			}
			if (this.displayList.includes(this.DIABLE_SMS)) {
				initialFields.disableSms = disableSms === '1'
			}
			if (this.displayList.includes(this.AUTO_SIGN)) {
				initialFields.autoSign = autoSign === '1'
			}
			if (this.displayList.includes(this.SETTLE_SYSTEM)) {
				if (afterBusinessLine) {
					initialFields.afterBusinessLine = afterBusinessLine + ''
				}
				if (beforeBusinessLine) {
					initialFields.beforeBusinessLine = beforeBusinessLine + ''
				}
				if (effectDate) {
					initialFields.effectDate = moment(effectDate)
				}
			}

			this.generalForm.setFieldsValue(initialFields)
		})
	}

	private getForm() {
		return new Promise((resolve, reject) => {
			this.generalForm.validateFields((err: any, values: any) => {
				if (!err) {
					if (values.hasOwnProperty('virtualNumber')) {
						values.virtualNumber = (values.virtualNumber || []).includes('01')
							? '1'
							: '0'
					}
					if (values.hasOwnProperty('businessCooperation')) {
						values.wholeProcess = (values.businessCooperation || []).includes(
							'01'
						)
							? '1'
							: '0'
						delete values.businessCooperation
					}
					if (values.hasOwnProperty('packagePdf')) {
						values.packagePdf = values.packagePdf ? '1' : '0'
					}
					if (values.hasOwnProperty('auditCancel')) {
						values.auditCancel = values.auditCancel ? '1' : '0'
					}
					if (values.hasOwnProperty('disableSms')) {
						values.disableSms = values.disableSms ? '1' : '0'
					}
					if (values.hasOwnProperty('disabelManual')) {
						values.disabelManual = values.disabelManual ? '1' : '0'
					}
					if (values.hasOwnProperty('autoSign')) {
						values.autoSign = values.autoSign ? '1' : '0'
					}
					if (values.hasOwnProperty('effectDate') && !!values.effectDate) {
						values.effectDate = values.effectDate.format('YYYY-MM-DD HH:mm:ss')
					}

					resolve({
						...values,
						manual: this.manual,
					})
				} else {
					reject()
				}
			})
		})
	}

	private beforeUpload(file: File, fileList: File[]) {
		debounceUpload(() => {
			const hide: any = this.$message.loading('上传中...', 0)
			uploadFiles(fileList)
				.then(async (res: any) => {
					const uploaded: any = (res && res.uploaded && res.uploaded[0]) || {}
					this.manual = {
						...uploaded.data,
						fileName: uploaded.file && uploaded.file.name,
					}

					this.$message.success('上传成功')
				})
				.catch(() => {
					this.$message.error(`上传失败`)
				})
				.finally(() => {
					hide()
				})
		})
		return false
	}

	private getFileInfo(fileId: string) {
		return RulesApi.manualPreview(fileId)
			.then((res: any) => {
				const data = (res && res.data) || {}
				this.$set(this.manual, 'previewUrl', data.previewUrl)
				this.$set(this.manual, 'fileUrl', data.fileUrl)
			})
			.catch(() => {
				this.$set(this.manual, 'previewUrl', '')
				this.$set(this.manual, 'fileUrl', '')
			})
	}

	private removeManual() {
		this.$confirm({
			title: '提示',
			content: '请确认是否删除该文件',
			onOk: () => {
				this.manual = {}
			},
		})
	}

	private async downloadManual() {
		if (!this.manual.fileUrl) {
			await this.getFileInfo(this.manual.fileId)
		}
		window.open(this.manual.fileUrl)
	}

	private previewManual(fileId: string) {
		this.visible = true
		if (!this.manual.previewUrl) {
			this.getFileInfo(this.manual.fileId)
		}
	}

	private created() {
		this.generalForm = this.$form.createForm(this)
	}
}
